import React from 'react';
import { createUseStyles } from 'react-jss';
import SectionHeading from '@src/components/SectionHeading';
import { Breakpoints } from '@ateams/components';
import userIllustration from '../ConfirmSubmissionModal/userIllustration.svg';
import Modal from '@src/components/Modal';
import { Button } from '@a_team/ui-components';

interface ConfirmationModalProps {
  onConfirm(): void;
  onClose(): void;
  open: boolean;
  isLoading?: boolean;
}

const useStyles = createUseStyles({
  modal: {
    zIndex: 10003,
    textAlign: 'center',
    width: '680px !important',
    padding: '40px !important',
  },
  heading: {
    margin: '40px 0 0 0',
    fontSize: 20,
  },
  copy1: {
    marginTop: 8,
    padding: '0',
    color: '#818388',
  },
  copy2: {
    marginTop: '24px',
    padding: '0 40px',
    color: '#222',
  },
  actionWrap: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '32px',
    paddingLeft: '12px',
    paddingRight: '12px',
    gap: '12px',
  },
  ctaButton: {
    marginRight: '24px',
    width: '160px',
    borderRadius: '8px',
  },
  [`@media (max-width: ${Breakpoints.sm}px)`]: {
    modal: {
      width: '95% !important',
      padding: '20px !important',
    },
  },
});

export default function ConfirmSubmissionModal(props: ConfirmationModalProps) {
  const styles = useStyles();
  const { onClose, onConfirm, isLoading, ...left } = props;

  return (
    <Modal onClose={props.onClose} {...left} className={styles.modal}>
      <div style={{ color: 'black' }}>
        <img src={userIllustration} style={{ width: 132 }} alt={'User'} />
        <SectionHeading className={styles.heading}>
          Are you ready to submit your profile for review?
        </SectionHeading>
        <p className={styles.copy1}>
          Next, our team will review your profile, so ensure it highlights your
          strengths. After reviewing, we’ll let you know if your skillset is a
          good fit for missions in the network.
        </p>
        <p className={styles.copy2}>Estimated time to review: up to 2 weeks</p>
        <div className={styles.actionWrap}>
          <Button
            variant="secondary"
            onClick={onClose}
            className={styles.ctaButton}
          >
            Go back
          </Button>

          <Button
            color="regular"
            onClick={onConfirm}
            className={styles.ctaButton}
            disabled={isLoading}
            loading={isLoading}
          >
            Submit
          </Button>
        </div>
      </div>
    </Modal>
  );
}
